import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import './v-enum-cell.component.scss';

@Component({
    selector: 'v-enum-cell',
    template: '{{ enumValue | enumAsString : enumType : enumName }}',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnumCellComponent<T> implements OnInit {

    @Input() enumType: T;
    @Input() enumName: string;
    @Input() enumValue: number;

    constructor() { }

    ngOnInit(): void {
    }
}
